import React from 'react';
import classNames from 'classnames';
import FileUtils from 'application/utils/FileUtils';

import VideoMediafilesPreviewItemSkeleton from 'application/components/VideoMediafilePreviewItemSkeleton';
import styles from './index.module.scss';
import ItemContent from '../ItemContent';
import EmenuItemContent from '../EmenuItemContent';

import { DraggableVideoMediafilePreviewItemProps } from './types';

const PreviewItem: React.FC<DraggableVideoMediafilePreviewItemProps> = ({
  file,
  className,
  onSetDuration,
  onRemoveMediafile,
  onCopyMediafile,
  isBlockedDurationEdit,
}) => (
  <div className={classNames(styles.StreamPreviewItem, className)}>
    {!file && <VideoMediafilesPreviewItemSkeleton />}
    {file?.itemType === 'emenu' && (
      <EmenuItemContent
        title={file.title}
        playDuration={file.playDuration}
        generationDuration={file.generationDuration}
      />
    )}
    {file && file.itemType !== 'emenu' && (
      <ItemContent
        imgLink={file.previewUrl}
        title={file.title}
        duration={file.duration}
        extension={FileUtils.getOriginalMediafileSource(file.sourcefiles)?.extension}
        playDuration={file.playDuration}
        onSetDuration={onSetDuration}
        id={file.id}
        onRemoveMediafile={onRemoveMediafile}
        onCopyMediafile={onCopyMediafile}
        isBlockedDurationEdit={isBlockedDurationEdit}
      />
    )}
  </div>
);

export default PreviewItem;
